import React from 'react';
// import { Link } from 'react-router-dom';

const References = () => (
  <div className="references">
    <div className="link-to" id="references" />
    <div className="title">
      <h3><a className="mail-link" href="/#contact">References are available upon request</a></h3>
    </div>
  </div>
);

export default References;
